import React from 'react';
import { useTranslation } from 'react-i18next';

import { Reset } from './reset.styled';

export const ResetBtn = (props) => {
  const { t } = useTranslation();
  return <Reset {...props}>{t('grid.resetflt')}</Reset>;
};
